import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import { DropdownMenuLink } from '@unowmooc/react-ui-kit'

import styles from './styles.module.scss'

const CellActionLink = ({ warning, data, ...rest }) => (
  <DropdownMenuLink
    {..._.omit(rest, ['shouldBeDisplayed'])}
    className={classnames(styles.cellActionLink, {
      [styles.warning]: _.isFunction(warning) ? warning(data) : warning,
    })}
  />
)

CellActionLink.defaultProps = {
  warning: false,
  data: undefined,
}

CellActionLink.propTypes = {
  children: PropTypes.node.isRequired,
  warning: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  data: PropTypes.shape({}),
}

export default CellActionLink
